import { ToggleSelector } from "../ToggleSelector";
import { ConsumptionDisplayMode } from "./consumptionTypes";

interface ConsumptionDisplayModeToggleProps {
  value: ConsumptionDisplayMode;
  onChange: (value: ConsumptionDisplayMode) => void;
  size?: "small" | "medium";
}

export const ConsumptionDisplayModeToggle = ({
  value,
  onChange,
  size = "medium",
}: ConsumptionDisplayModeToggleProps) => (
  <ToggleSelector<ConsumptionDisplayMode>
    selectedValue={value}
    setSelectedValue={onChange}
    availableValueLabels={{ percentage: "percentage", mass: "mass" }}
    size={size}
  />
);
